var Backbone = require('backbone');
var Marionette = require('marionette');
var Dialog = require('Dialog');
var Labels = EY.Consultation.Labels;

var Confirmation = Marionette.View.extend({
    template: '#dialogConfirmation'
});

module.exports.show = function (options) {
    var message = options.message;

    return Dialog.show({
        cancelLabel: Labels.No,
        headerLabel: Labels.DialogTitleWarning,
        saveLabel: Labels.Yes,
        view: new Confirmation({ model: new Backbone.Model({ message: message }) })
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Dialog/DialogConfirmation.js